var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIconRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.75C5.07 21.75 0.25 16.93 0.25 11C0.25 5.07 5.07 0.25 11 0.25C16.93 0.25 21.75 5.07 21.75 11C21.75 16.93 16.93 21.75 11 21.75ZM11 1.75C5.9 1.75 1.75 5.9 1.75 11C1.75 16.1 5.9 20.25 11 20.25C16.1 20.25 20.25 16.1 20.25 11C20.25 5.9 16.1 1.75 11 1.75Z",
    fill: "#B2AEBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.25C10.59 14.25 10.25 13.91 10.25 13.5V7.5C10.25 7.09 10.59 6.75 11 6.75C11.41 6.75 11.75 7.09 11.75 7.5V13.5C11.75 13.91 11.41 14.25 11 14.25Z",
    fill: "#B2AEBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 15.2499C10.8099 15.2499 10.6199 15.1799 10.4699 15.0299L7.46994 12.0299C7.17994 11.7399 7.17994 11.2599 7.46994 10.9699C7.75994 10.6799 8.23994 10.6799 8.52994 10.9699L10.9999 13.4399L13.4699 10.9699C13.7599 10.6799 14.2399 10.6799 14.5299 10.9699C14.8199 11.2599 14.8199 11.7399 14.5299 12.0299L11.5299 15.0299C11.3799 15.1799 11.1899 15.2499 10.9999 15.2499Z",
    fill: "#B2AEBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconRound);
export default __webpack_public_path__ + "static/media/download-icon-round.c1cdb0c3.svg";
export { ForwardRef as ReactComponent };